import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import isEqual from 'lodash-es/isEqual'

import { NOTIFICATION_TYPE } from '../../../../../constants/common'
import {
  useInlineNotifications,
  useValidationWithoutFormikNotifications,
} from '../../../../../hooks'
import { getItemsIds } from '../../../../../utils/common'
import {
  getDropResultForUpdateRowsPosition,
  getUpdatedDraggedRowsPosition,
} from '../../../../Table'
import { DOC_FLOW_EDIT_SEQUENCE_MODAL_PERMANENT_NOTIFICATION_ID } from '../../DocFlowEditSequenceModal.constants'

export function useSequenceModalActions({ files, item, onClose, onSubmit }) {
  const { t } = useTranslation()

  const initialNotifications = [
    {
      id: DOC_FLOW_EDIT_SEQUENCE_MODAL_PERMANENT_NOTIFICATION_ID,
      text: t(
        'DocumentStapling.EditSplittedDocumentModalPermanentNotificationKey'
      ),
      type: NOTIFICATION_TYPE.info,
    },
  ]

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications({ initialNotifications })

  const [isCloseConfirm, setCloseConfirm] = useState(false)
  const [updatedList, setUpdatedList] = useState(files)
  const [isLoading, setLoading] = useState(false)

  const validateData = { files: updatedList }

  const { isValidForm, notificationList } =
    useValidationWithoutFormikNotifications({
      notifications,
      validateData,
      validationSchemaProps: {
        formValues: validateData,
        initialValues: { files },
      },
      onRemoveNotification: handleRemoveNotification,
      onSetNotification: handleAddNotification,
    })

  function handleClose() {
    if (!isEqual(files, updatedList)) {
      setCloseConfirm(true)

      return
    }

    onClose()
  }

  function handleDragEnd({ active, over }) {
    const activeId = active?.id
    const overId = over?.id

    if (!over || activeId === overId) {
      return
    }

    const result = getDropResultForUpdateRowsPosition({
      activeId,
      items: updatedList,
      overId,
    })

    if (!result) {
      return
    }

    const updatedDraggedRows = getUpdatedDraggedRowsPosition({
      itemPositionKey: 'position',
      result,
      rows: updatedList,
    })

    if (updatedDraggedRows) {
      const newRows = updatedDraggedRows.sort((a, b) => a.position - b.position)

      setUpdatedList(newRows)
    }
  }

  function handleSubmit() {
    if (!isValidForm()) {
      return
    }

    setLoading(true)

    onSubmit({
      item,
      updatedList: getItemsIds(updatedList),
    }).finally(() => {
      setLoading(false)
    })
  }

  return {
    handleClose,
    handleDragEnd,
    handleSubmit,
    isCloseConfirm,
    isLoading,
    notificationList,
    setCloseConfirm,
    updatedList,
  }
}
